export { DiscountCodeDisclosure } from './DiscountCodeDisclosure';
export type {
  DiscountCodeDisclosureLabels,
  DiscountCodeDisclosureProps,
} from './DiscountCodeDisclosure.types';
